// App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';


// Stili
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

// Componenti principali
import Login from './componenti/Login';
import Home from './componenti/Home';
import Dashboard from './componenti/Dashboard';
import DashboardStaff from './componenti/DashboardStaff';
import DashboardGenitore from './componenti/DashboardGenitore';
/* import DashboardAllenatoreLoggato from './componenti/DashboardAllenatoreLoggato';  */

// Componenti Admin
import GenitoreForm from './componenti/GenitoreForm';
import GiocatoreForm from './componenti/GiocatoreForm';
import QuoteForm from './componenti/QuoteForm';
import StaffForm from './componenti/StaffForm';
import Notizie from './componenti/Notizie';
import Eventi from './componenti/Eventi';
import Media from './componenti/Media';
import CategorieForm from './componenti/CategorieForm';
import ScadenzaRate from './componenti/ScadenzaRate';
import MonitoraggioIscrizioni from './componenti/MonitoraggioIscrizioni';
import BachecaRisultati from './componenti/BachecaRisultati';
import MovimentiCassaForm from './componenti/MovimentiCassaForm';
import AggiornaMovimentiCassa from './componenti/AggiornaMovimentiCassa';
import MonitoraggioDocumentiGiocatore from './componenti/MonitoraggioDocumentiGiocatore';
import MonitoraggioNotifichePagamenti from './componenti/MonitoraggioNotifichePagamenti';
import MagazzinoForm from './componenti/MagazzinoForm';
import AcquistoMaterialeForm from './componenti/AcquistoMaterialeForm';

// Componenti Staff
import ConvocazioneForm from './componenti/ConvocazioneForm';
import ProgrammaGaraForm from './componenti/ProgrammaGaraForm';
import StatistichePresenzeForm from './componenti/StatistichePresenzeForm';
import RisultatoGaraForm from './componenti/RisultatoGaraForm';
import StatisticheReti from './componenti/StatisticheReti';
import AllenamentiForm from './componenti/AllenamentiForm';
import AllenamentiStaff from './componenti/AllenamentiStaff';
import AggiornaAllenamenti from './componenti/AggiornaAllenamenti';
import PresenzaForm from './componenti/PresenzaForm';
import StatistichePresenzeStaff from './componenti/StatistichePresenzeStaff';
import PresenzaStaffForm from './componenti/PresenzaStaffForm';
import PresenzaGaraStaff from './componenti/PresenzaGaraStaff';


// Componenti Admin-aggiornamento
import AggiornaGenitore from './componenti/AggiornaGenitore';
import AggiornaGiocatore from './componenti/AggiornaGiocatore';
import AggiornaStaff from './componenti/AggiornaStaff';
import AggiornaProgrammaGara from './componenti/AggiornaProgrammaGara';
import AggiornaNotizie from './componenti/AggiornaNotizie';
import AggiornaEventi from './componenti/AggiornaEventi';
import AggiornaUtenti from './componenti/AggiornaUtenti';
import AggiornaMagazzino from './componenti/AggiornaMagazzino';
import AggiornaAcquistiMateriale from './componenti/AggiornaAcquistiMateriale';

// Componenti Genitore
import AggGenitore from './componenti/AggGenitore';
import AggGiocatore from './componenti/AggGiocatore'
import AggiornaAccountGenitore from './componenti/AggiornaAccountGenitore';
import PresenzaGenitore from './componenti/PresenzaGenitore';
import PresenzaGaraGenitore from './componenti/PresenzaGaraGenitore';
import DocumentiGenitore from './componenti/DocumentiGenitore';

// Route protette
import AdminRoute from './componenti/AdminRoute';
import StaffRoute from './componenti/StaffRoute';
import GenitoreRoute from './componenti/GenitoreRoute';
/*import AllenatoreRoute from './componenti/AllenatoreRoute'; da implementare */

// Header
import Header from './componenti/Header';


export default function App() {
  

  return (
    <>
      <Header />
      <ToastContainer position="top-center" autoClose={3000} />
      <Routes>
        {/* Rotte pubbliche */}
        <Route path="/" element={<div className="sfondo-immagine"><Home /></div>} />
        <Route path="/login" element={<div className="sfondo-immagine"><Login /></div>} />

        {/* Dashboard per ruolo */}
        <Route path="/gestionale" element={<AdminRoute><Dashboard /></AdminRoute>} />
        <Route path="/gestionale1" element={<StaffRoute><DashboardStaff /></StaffRoute>} />
        <Route path="/gestionale2" element={<GenitoreRoute><DashboardGenitore /></GenitoreRoute>} />
        
        
        {/* Rotte Admin */}
        <Route path="/admin/genitori" element={<AdminRoute><div className="sfondo-immagine"><GenitoreForm /></div></AdminRoute>} />
        <Route path="/admin/giocatore" element={<AdminRoute><div className="sfondo-immagine"><GiocatoreForm /></div></AdminRoute>} />
        <Route path="/admin/quote" element={<AdminRoute><div className="sfondo-immagine"><QuoteForm /></div></AdminRoute>} />
        <Route path="/admin/staff" element={<AdminRoute><div className="sfondo-immagine"><StaffForm /></div></AdminRoute>} />
        <Route path="/admin/notizie" element={<AdminRoute><div className="sfondo-immagine"><Notizie /></div></AdminRoute>} />
        <Route path="/admin/eventi" element={<AdminRoute><div className="sfondo-immagine"><Eventi /></div></AdminRoute>} />
        <Route path="/admin/media" element={<AdminRoute><div className="sfondo-immagine"><Media /></div></AdminRoute>} />
        <Route path="/admin/categorie" element={<AdminRoute><div className="sfondo-immagine"><CategorieForm /></div></AdminRoute>} />
        <Route path="/admin/scadenze" element={<AdminRoute><div className="sfondo-immagine"><ScadenzaRate /></div></AdminRoute>} />
        <Route path="/admin/statistiche" element={<AdminRoute><div className="sfondo-immagine"><MonitoraggioIscrizioni /></div></AdminRoute>} />
        <Route path="/admin/statistiche-presenze" element={<AdminRoute><div className="sfondo-immagine"><StatistichePresenzeForm /></div></AdminRoute>} />
        <Route path="/admin/bacheca-risultati" element={<AdminRoute><div className="sfondo-immagine"><BachecaRisultati /></div></AdminRoute>}/>
        <Route path="/admin/programma-gara" element={<AdminRoute><div className="sfondo-immagine"><ProgrammaGaraForm /></div></AdminRoute>} />
        <Route path="/gestionale/admin/movimenti-cassa" element={<MovimentiCassaForm />} />
        <Route path="/admin/documenti-giocatori" element={<AdminRoute><div className="sfondo-immagine"><MonitoraggioDocumentiGiocatore /></div></AdminRoute>}/>
        <Route path="/gestionale2/admin/monitoraggio-notifiche-pagamenti" element={<AdminRoute><div className="sfondo-immagine"><MonitoraggioNotifichePagamenti /></div></AdminRoute>}/>
        <Route path="/gestionale/magazzino" element={<AdminRoute><div className="sfondo-immagine"><MagazzinoForm /></div></AdminRoute>} />
        <Route path="/gestionale/acquisto-materiale" element={<AdminRoute><AcquistoMaterialeForm /></AdminRoute>}/>

        {/* Rotte Aggiorna Admin */}
        <Route path="/admin/aggiorna-genitori" element={<AdminRoute><div className="sfondo-immagine"><AggiornaGenitore /></div></AdminRoute>} />
        <Route path="/admin/aggiorna-giocatori" element={<AdminRoute><div className="sfondo-immagine"><AggiornaGiocatore /></div></AdminRoute>} />
        <Route path="/admin/aggiorna-staff" element={<AdminRoute><div className="sfondo-immagine"><AggiornaStaff /></div></AdminRoute>} />
        <Route path="/admin/aggiorna-notizie" element={<AdminRoute><div className="sfondo-immagine"><AggiornaNotizie /></div></AdminRoute>} />
        <Route path="/admin/aggiorna-eventi" element={<AdminRoute><div className="sfondo-immagine"><AggiornaEventi /></div></AdminRoute>} />
        <Route path="/admin/aggiorna-utenti" element={<AdminRoute><div className="sfondo-immagine"><AggiornaUtenti /></div></AdminRoute>} />
        <Route path="/admin/aggiorna-programmagara" element={<AdminRoute><div className="sfondo-immagine"><AggiornaProgrammaGara /></div></AdminRoute>} />
        <Route path='/admin/statistiche-presenze' element={<AdminRoute><div className='sfondo-immagine'><PresenzaForm /></div></AdminRoute>}/>
        <Route path="/gestionale/admin/movimenti-cassa/aggiorna" element={<AggiornaMovimentiCassa />} />
        <Route path="/gestionale/aggiorna-magazzino" element={<AdminRoute><div className="sfondo-immagine"><AggiornaMagazzino /></div></AdminRoute>} />
        <Route path="/gestionale/aggiorna-acquisti-materiale" element={<AdminRoute><AggiornaAcquistiMateriale /></AdminRoute>}/>

      {/* Rotte Staff */}
      <Route path="/gestionale1/convocazioni" element={<StaffRoute><div className="sfondo-immagine"><ConvocazioneForm /></div></StaffRoute>} />
      <Route path="/gestionale1/allenamentiForm" element={<StaffRoute><div className="sfondo-immagine"><AllenamentiForm /></div></StaffRoute>} />
      <Route path="/gestionale1/allenamentiStaff" element={<StaffRoute><div className="sfondo-immagine"><AllenamentiStaff /></div></StaffRoute>} />
      <Route path="/gestionale1/presenzestaff" element={<StaffRoute><div className="sfondo-immagine"><PresenzaStaffForm /></div></StaffRoute>} />
      <Route path="/gestionale1/risultati-gara" element={<StaffRoute><div className="sfondo-immagine"><RisultatoGaraForm /></div></StaffRoute>}/>
      <Route path="/gestionale1/statistiche-reti" element={<StaffRoute><div className="sfondo-immagine"><StatisticheReti /></div></StaffRoute>}/>
      <Route path='/gestionale1/aggiorna-allenamenti' element={<StaffRoute><div className='sfondo-immagine'><AggiornaAllenamenti /></div></StaffRoute>}/>
      <Route path='/gestionale1/statistiche-presenzestaff' element={<StaffRoute><div className='sfondo-immagine'><StatistichePresenzeStaff /></div></StaffRoute>}/>
      <Route path="/gestionale1/presenze-gara-staff" element={<StaffRoute><div className='sfondo-immagine'><PresenzaGaraStaff /></div></StaffRoute>} />
      

      {/* Rotte Genitore */}
      <Route path="/gestionale2/aggiorna-figli" element={<GenitoreRoute><div className="sfondo-immagine"><AggGiocatore /></div></GenitoreRoute>} />
      <Route path="/gestionale2/aggiorna-genitore" element={<GenitoreRoute><div className="sfondo-immagine"><AggGenitore /></div></GenitoreRoute>} />
      <Route path="/gestionale2/aggiorna-account-genitore" element={<GenitoreRoute><div className="sfondo-immagine"><AggiornaAccountGenitore /></div></GenitoreRoute>} />
      <Route path="/gestionale2/presenza-genitore" element={<GenitoreRoute><div className="sfondo-immagine"><PresenzaGenitore /></div></GenitoreRoute>} />
      <Route path="/gestionale2/presenze-gara-genitore" element={<GenitoreRoute><div className="sfondo-immagine"><PresenzaGaraGenitore /></div></GenitoreRoute>} />
      <Route path="/gestionale2/documenti" element={<GenitoreRoute><div className='sfondo-immagine'><DocumentiGenitore /></div></GenitoreRoute>} />

        {/* Rotta fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
